import { Link, Typography } from "@mui/material";
import React from "react";
import { ActivityVariant } from "../activity";
import { Link as RouterLink } from "react-router";

export const ActivtyHeadingTitleColor: any = {
  success: "success.main",
  warning: "warning.main",
  error: "error.main",
  info: "info.main",
  primary: "primary.text",
  secondary: "text.secondary",
};

interface ActivityHeadingTitleProps {
  user?: string;
  label: string;
  action?: string;
  variant?: ActivityVariant;
  linkToResource?: string;
}

export const ActivityHeadingTitle: React.FC<ActivityHeadingTitleProps> = (props) => {
  const { user, action, label, variant = "success", linkToResource } = props;
  return (
    <Typography fontWeight={500}>
      {user && user !== "System" && (
        <Typography component="span" fontWeight={600}>
          {user}
        </Typography>
      )}
      {action && (
        <Typography component="span" color="text.secondary">
          {" " + action}
        </Typography>
      )}
      {(!action || action === "") && (
        <Typography component="span" color="text.secondary">
          {" "}
        </Typography>
      )}
      <Link
        target="_blank"
        underline="hover"
        color={ActivtyHeadingTitleColor[variant]}
        fontWeight={500}
        sx={{ cursor: "pointer" }}
        component={RouterLink}
        to={linkToResource ?? ""}
      >
        {label}
      </Link>
    </Typography>
  );
};

export default ActivityHeadingTitle;
